import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { type IVerifoneTerminal } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

export type IEditVerifoneTerminalResponse = Pick<
  IVerifoneTerminal,
  'name' | 'serialNumber'
>;

type EditVerifoneTerminalFormData = IEditVerifoneTerminalResponse;

export interface IEditVerifoneTerminalRequest {
  title: string;
  terminal: WithRef<IVerifoneTerminal>;
}

@Component({
  selector: 'pr-edit-verifone-terminal-dialog',
  templateUrl: './edit-verifone-terminal-dialog.component.html',
  styleUrls: ['./edit-verifone-terminal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditVerifoneTerminalDialogComponent {
  form = new TypedFormGroup<EditVerifoneTerminalFormData>({
    name: new TypedFormControl<string>('', Validators.required),
    serialNumber: new TypedFormControl<string>('', Validators.required),
  });

  constructor(
    private _dialogRef: MatDialogRef<
      EditVerifoneTerminalDialogComponent,
      IEditVerifoneTerminalResponse
    >,
    @Inject(MAT_DIALOG_DATA) public data: IEditVerifoneTerminalRequest
  ) {
    this.form.patchValue(data.terminal);
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }
    this._dialogRef.close(this.form.value);
  }
}
